module.exports = __webpack_public_path__ + "img/Pic_ZHBG_YER_d.020c65c3.gif";